import { Slide } from '@material-ui/core';

interface Props {
  animateIn: boolean;
  isMobile: boolean;
  [x: string]: any;
}

export const AnimationWrapper = (props: Props) => {
  const { children, animateIn, isMobile } = props;
  return !isMobile ? (
    children
  ) : (
    <Slide direction="left" in={animateIn} mountOnEnter unmountOnExit>
      {children}
    </Slide>
  );
};
